var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0498 7.5V3.5H2.0498V21.5H22.0498V7.5H12.0498ZM6.0498 19.5H4.0498V17.5H6.0498V19.5ZM6.0498 15.5H4.0498V13.5H6.0498V15.5ZM6.0498 11.5H4.0498V9.5H6.0498V11.5ZM6.0498 7.5H4.0498V5.5H6.0498V7.5ZM10.0498 19.5H8.0498V17.5H10.0498V19.5ZM10.0498 15.5H8.0498V13.5H10.0498V15.5ZM10.0498 11.5H8.0498V9.5H10.0498V11.5ZM10.0498 7.5H8.0498V5.5H10.0498V7.5ZM20.0498 19.5H12.0498V17.5H14.0498V15.5H12.0498V13.5H14.0498V11.5H12.0498V9.5H20.0498V19.5ZM18.0498 11.5H16.0498V13.5H18.0498V11.5ZM18.0498 15.5H16.0498V17.5H18.0498V15.5Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselProjects);
export default __webpack_public_path__ + "static/media/carousel-projects.5f980a8efb816bf21780d45150ad494a.svg";
export { ForwardRef as ReactComponent };